import { apiFetch } from "../serverApi";

// Posts JSON to one of the account servlets and returns the JSON reply
export async function postAccount(path, body, signal) {
    const res = await apiFetch(path, {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(body),
        signal,
    });
    return res.json();
}
